'use client'

import UpgradeButton from '@/components/upgrade/UpgradeButton'
import { useSessionSummary } from '@/lib/session/sessionSummary'

// The header's "Pricing" entry: the plans, from the nav. Resolved on the
// client (the header itself stays static) and gone for an account with
// everything the store sells, where there is nothing left to sell.
export default function LandingNavPricing({ signedIn: forced }: { signedIn?: boolean }) {
  const session = useSessionSummary()
  const unlimited = forced === undefined && session.isPro
  return <UpgradeButton isPro={unlimited} appearance="nav" />
}
